module.exports = __webpack_public_path__ + "static/img/ydh2-benefit-bg.1f2441c0.png";